// TODO: remove this helper after refactor to tournament manager
import TournamentOrganizer from "tournament-organizer";
import { TOURNAMENT_DEFAULT_SCORING, TOURNAMENT_FIDE_GAME_RESULT, TOURNAMENT_GAME_RESULT, } from "../constants.js";
import { formatDate } from "../utils/date-helper.js";
export const toTourneyMatches = (games) => {
    return games
        .filter((g) => g.whiteUsername || g.blackUsername)
        .map((g) => {
        const whiteRoundGames = games.filter((g1) => g1.roundNumber === g.roundNumber &&
            g1.whiteUsername === g.whiteUsername);
        const blackRoundGames = games.filter((g1) => g1.roundNumber === g.roundNumber &&
            g1.whiteUsername === g.blackUsername);
        // a match can have multiple games, hence count win, loss, draw
        const values = {
            id: g.matchGUID,
            active: false,
            bye: g.whiteResult === TOURNAMENT_GAME_RESULT.PAIRINGBYE ||
                g.blackResult === TOURNAMENT_GAME_RESULT.PAIRINGBYE,
            player1: {
                id: g.whiteUsername,
                win: whiteRoundGames.reduce((win, g1) => {
                    return (win +
                        (g1.whiteUsername === g.whiteUsername
                            ? g1.whiteResult === TOURNAMENT_GAME_RESULT.WIN ||
                                g1.whiteResult === TOURNAMENT_GAME_RESULT.FORFEITW ||
                                g1.whiteResult === TOURNAMENT_GAME_RESULT.PAIRINGBYE
                                ? 1
                                : 0
                            : g1.blackResult === TOURNAMENT_GAME_RESULT.WIN ||
                                g1.blackResult === TOURNAMENT_GAME_RESULT.FORFEITW ||
                                g1.blackResult === TOURNAMENT_GAME_RESULT.PAIRINGBYE
                                ? 1
                                : 0));
                }, 0),
                loss: whiteRoundGames.reduce((loss, g1) => {
                    return (loss +
                        (g1.whiteUsername === g.whiteUsername
                            ? g1.whiteResult === TOURNAMENT_GAME_RESULT.LOSS ||
                                g1.whiteResult === TOURNAMENT_GAME_RESULT.FORFEITL
                                ? 1
                                : 0
                            : g1.blackResult === TOURNAMENT_GAME_RESULT.LOSS ||
                                g1.blackResult === TOURNAMENT_GAME_RESULT.FORFEITL
                                ? 1
                                : 0));
                }, 0),
                draw: whiteRoundGames.reduce((draw, g1) => {
                    return (draw +
                        (g1.whiteUsername === g.whiteUsername
                            ? g1.whiteResult === TOURNAMENT_GAME_RESULT.DRAW ||
                                g1.whiteResult === TOURNAMENT_GAME_RESULT.FORFEITD
                                ? 1
                                : 0
                            : g1.blackResult === TOURNAMENT_GAME_RESULT.DRAW ||
                                g1.blackResult === TOURNAMENT_GAME_RESULT.FORFEITD
                                ? 1
                                : 0));
                }, 0),
            },
            player2: {
                id: g.blackUsername,
                win: blackRoundGames.reduce((win, g1) => {
                    return (win +
                        (g1.whiteUsername === g.whiteUsername
                            ? g1.whiteResult === TOURNAMENT_GAME_RESULT.WIN ||
                                g1.whiteResult === TOURNAMENT_GAME_RESULT.FORFEITW ||
                                g1.whiteResult === TOURNAMENT_GAME_RESULT.PAIRINGBYE
                                ? 1
                                : 0
                            : g1.blackResult === TOURNAMENT_GAME_RESULT.WIN ||
                                g1.blackResult === TOURNAMENT_GAME_RESULT.FORFEITW ||
                                g1.blackResult === TOURNAMENT_GAME_RESULT.PAIRINGBYE
                                ? 1
                                : 0));
                }, 0),
                loss: blackRoundGames.reduce((loss, g1) => {
                    return (loss +
                        (g1.whiteUsername === g.whiteUsername
                            ? g1.whiteResult === TOURNAMENT_GAME_RESULT.LOSS ||
                                g1.whiteResult === TOURNAMENT_GAME_RESULT.FORFEITL
                                ? 1
                                : 0
                            : g1.blackResult === TOURNAMENT_GAME_RESULT.LOSS ||
                                g1.blackResult === TOURNAMENT_GAME_RESULT.FORFEITL
                                ? 1
                                : 0));
                }, 0),
                draw: blackRoundGames.reduce((draw, g1) => {
                    return (draw +
                        (g1.whiteUsername === g.whiteUsername
                            ? g1.whiteResult === TOURNAMENT_GAME_RESULT.DRAW ||
                                g1.whiteResult === TOURNAMENT_GAME_RESULT.FORFEITD
                                ? 1
                                : 0
                            : g1.blackResult === TOURNAMENT_GAME_RESULT.DRAW ||
                                g1.blackResult === TOURNAMENT_GAME_RESULT.FORFEITD
                                ? 1
                                : 0));
                }, 0),
            },
            match: g.board,
            round: g.roundNumber,
            path: null,
            meta: null,
        };
        return values;
    });
};
export const toTourneyPlayers = (tournament, players, games = []) => {
    if (tournament.type === "RoundRobin") {
        players.sort((p1, p2) => p1.startingRank - p2.startingRank);
    }
    const playerValues = players.map((p) => {
        // get all the games player've played
        const playerGames = games.filter((m) => m.blackUsername === p.username || m.whiteUsername === p.username);
        // a match can have multiple games, but the system now can only support 1 game per match
        // if it's multiple games per a single match (best of x), then need to update to handle that case
        const values = {
            id: p.username,
            name: p.username,
            active: tournament.type === "Elim" ? true : p.active,
            value: p.seed,
            meta: {},
            matches: playerGames.map((g) => {
                // a match can have multi games, but the system now can only support 1 game per match,
                // so get opponent base on the first game for now,
                const opponent = g.whiteUsername === p.username ? g.blackUsername : g.whiteUsername;
                const color = g.whiteUsername === p.username ? "w" : "b";
                const result = g.whiteUsername === p.username ? g.whiteResult : g.blackResult;
                const win = result === TOURNAMENT_GAME_RESULT.WIN ||
                    result === TOURNAMENT_GAME_RESULT.FORFEITW ||
                    result === TOURNAMENT_GAME_RESULT.PAIRINGBYE
                    ? 1
                    : 0;
                const loss = result === TOURNAMENT_GAME_RESULT.LOSS ||
                    result === TOURNAMENT_GAME_RESULT.FORFEITL
                    ? 1
                    : 0;
                const draw = result === TOURNAMENT_GAME_RESULT.DRAW ||
                    result === TOURNAMENT_GAME_RESULT.FORFEITD
                    ? 1
                    : 0;
                const bye = g.whiteResult === TOURNAMENT_GAME_RESULT.PAIRINGBYE ||
                    g.blackResult === TOURNAMENT_GAME_RESULT.PAIRINGBYE; // 10 = PAIRING_BYE
                return {
                    id: g.matchGUID,
                    pairUpDown: false,
                    opponent,
                    seating: color === "w" ? 1 : -1,
                    bye,
                    // a match can have multiple games, hence count win, loss, draw in a particular match
                    win,
                    loss,
                    draw,
                    round: g.roundNumber,
                };
            }),
        };
        return values;
    });
    return playerValues;
};
const enterElimTourneyResult = (tourney, games) => {
    // with Elim, we have to manual reinput result of played games
    // to determine next pairings
    tourney.matches.forEach((m) => {
        const game = games.find((g) => g.roundNumber === m.round &&
            g.board === m.match &&
            (g.whiteUsername || g.blackUsername));
        if (!game) {
            return;
        }
        // we don't need to reconstruct result of a pairing bye game
        const ignoreResultValues = [
            TOURNAMENT_GAME_RESULT.PAIRINGBYE,
            TOURNAMENT_GAME_RESULT.FULLBYE,
            TOURNAMENT_GAME_RESULT.HALFBYE,
            TOURNAMENT_GAME_RESULT.ZEROBYE,
            TOURNAMENT_GAME_RESULT.DISQUALIFIED,
        ];
        if (ignoreResultValues.includes(game.whiteResult) ||
            ignoreResultValues.includes(game.blackResult)) {
            return;
        }
        else {
            let player1Wins = 0;
            let player2Wins = 0;
            let draws = 0;
            if (game.whiteUsername === m.player1.id) {
                if (game.whiteResult === TOURNAMENT_GAME_RESULT.WIN ||
                    game.whiteResult === TOURNAMENT_GAME_RESULT.FORFEITW) {
                    player1Wins = 1;
                }
                if (game.blackResult === TOURNAMENT_GAME_RESULT.WIN ||
                    game.blackResult === TOURNAMENT_GAME_RESULT.FORFEITW) {
                    player2Wins = 1;
                }
                if (game.whiteResult === TOURNAMENT_GAME_RESULT.DRAW ||
                    game.whiteResult === TOURNAMENT_GAME_RESULT.FORFEITD) {
                    draws = 1;
                }
            }
            else {
                if (game.blackResult === TOURNAMENT_GAME_RESULT.WIN ||
                    game.blackResult === TOURNAMENT_GAME_RESULT.FORFEITW) {
                    player1Wins = 1;
                }
                else if (game.blackResult === TOURNAMENT_GAME_RESULT.LOSS ||
                    game.blackResult === TOURNAMENT_GAME_RESULT.FORFEITL) {
                    player2Wins = 1;
                }
                else if (game.blackResult === TOURNAMENT_GAME_RESULT.DRAW ||
                    game.blackResult === TOURNAMENT_GAME_RESULT.FORFEITD) {
                    draws = 1;
                }
            }
            tourney.enterResult(m.id, player1Wins, player2Wins, draws);
        }
    });
};
export const getTourney = (tournament, games, // all the played games in the tournament
players // all the players participated in this round
) => {
    const defaultOptions = {
        id: tournament.id,
        name: tournament.name,
        seating: true,
        status: "stage-one",
        round: 1,
        sorting: "ascending",
        scoring: TOURNAMENT_DEFAULT_SCORING,
        meta: {},
        stageOne: {
            format: "single-elimination",
            consolation: false,
            rounds: tournament.totalRounds,
            initialRound: 1,
            maxPlayers: players.length,
        },
        stageTwo: {
            format: null, // no stage two
            consolation: false,
            advance: {
                value: 0,
                method: "all",
            },
        },
        matches: toTourneyMatches(games),
        players: toTourneyPlayers(tournament, players, games),
    };
    switch (tournament.type) {
        case "Swiss": {
            defaultOptions.stageOne.format = "swiss";
            break;
        }
        case "Robin": {
            defaultOptions.stageOne.format = "round-robin";
            break;
        }
        case "Elim": {
            defaultOptions.stageOne.format = "single-elimination";
            break;
        }
    }
    const organizer = new TournamentOrganizer();
    const tourney = organizer.reloadTournament(defaultOptions);
    return tourney;
};
export const toTRFBXData = (params) => {
    const { tournament, players, games } = params;
    return {
        system: "dutch",
        tournament: {
            name: tournament.name,
            city: "Chesssquad Academy",
            federation: "Chesssquad Academy",
            startDate: formatDate(tournament.startTime, "DD/MM/YYYY"),
            endDate: tournament.finishTime
                ? formatDate(tournament.finishTime, "DD/MM/YYYY")
                : null,
            numberOfPlayers: players.length,
            numberOfRatedPlayers: 0,
            numberOfTeams: 0,
            typeOfTournament: "Individual: Swiss System",
            chiefArbiter: "Chesssquad Academy",
            deputyChiefArbiter: "Chesssquad Academy",
            allottedTimesPerMovesOrGame: "moves/time, increment",
            numberOfRounds: tournament.totalRounds,
            scoring: {
                win: 1.0,
                draw: 0.5,
                lose: 0,
                zeroBye: 0,
                paringBye: 1,
                forfeitLoss: 0,
            },
        },
        players: players
            .map((p, i) => {
            return {
                ...p,
                currentRank: i + 1,
            };
        })
            .sort((a, b) => a.startingRank - b.startingRank)
            .map((p) => {
            const sexIndex = p.user.dna?.indexOf("male") ?? -1;
            const rounds = [];
            for (let i = 0; i < tournament.currentRound; i++) {
                const roundNumber = i + 1;
                const roundStarted = games.some((g) => g.roundNumber === roundNumber);
                if (!roundStarted) {
                    continue;
                }
                const roundGame = games.find((g) => g.roundNumber === roundNumber &&
                    (g.whiteUsername === p.username || g.blackUsername === p.username));
                rounds.push(roundGame); // null equals unparticipated
            }
            return {
                dataIdentificationNumber: "001",
                startingRank: p.startingRank,
                sex: sexIndex >= 0 ? "m" : "w",
                name: p.user.name ?? `${p.user.first_name}`,
                points: p.scoreBeforeGame,
                currentRank: p.currentRank,
                active: p.active && p.isParticipating,
                rounds: rounds.map((g) => {
                    if (!g) {
                        return {
                            opponentStartingRank: undefined,
                            color: "-",
                            result: TOURNAMENT_FIDE_GAME_RESULT[TOURNAMENT_GAME_RESULT.DISQUALIFIED],
                        };
                    }
                    const opp = players.find((p1) => g.whiteUsername === p.username
                        ? p1.username === g.blackUsername
                        : p1.username === g.whiteUsername);
                    const currResult = p.username === g.whiteUsername ? g.whiteResult : g.blackResult;
                    return {
                        opponentStartingRank: opp ? opp.startingRank : undefined,
                        color: opp ? (p.username === g.whiteUsername ? "w" : "b") : "-",
                        result: TOURNAMENT_FIDE_GAME_RESULT[currResult],
                    };
                }),
            };
        }),
    };
};
export const getMatchups = async (params, executor) => {
    const { players, tournament, games, roundNumber } = params;
    if (players.every((p) => !p.active))
        return [];
    if (tournament.type === "Swiss") {
        // for swiss, use bbppairing
        const bbpPairs = await executor(toTRFBXData(params));
        if (!bbpPairs) {
            return [];
        }
        return bbpPairs.map((pair) => {
            const whiteStartingRank = pair[0];
            const blackStartingRank = pair[1];
            return {
                whiteUsername: players.find((p) => p.startingRank === Number(whiteStartingRank))?.username,
                blackUsername: players.find((p) => p.startingRank === Number(blackStartingRank))?.username,
            };
        });
    }
    const tourney = getTourney(tournament, games, players);
    console.log("tourney after reload", JSON.stringify(tourney));
    console.debug("bye players", tourney.matches
        .filter((m) => m.bye)
        .reduce((curr, m) => {
        if (m.player1) {
            curr.push(m.player1.id);
        }
        else {
            curr.push(m.player2.id);
        }
        return curr;
    }, []));
    tourney.start();
    if (tournament.type === "Elim") {
        enterElimTourneyResult(tourney, games);
    }
    const newMatchups = tourney.matches.filter((m) => m.round === roundNumber);
    return newMatchups.map((matchup) => ({
        whiteUsername: matchup.player1 ? matchup.player1.id : null,
        blackUsername: matchup.player2 ? matchup.player2.id : null,
    }));
};
export const getStandings = (tournament, games, // all the played games in the tournament
players // all players participated in this round
) => {
    const tourney = getTourney(tournament, games, players);
    return tourney
        .standings(false)
        .map((s) => {
        return {
            gamePoints: s.gamePoints,
            games: s.games,
            matchPoints: s.matchPoints,
            matches: s.matches,
            player: {
                id: s.player.id,
                name: s.player.name,
                active: s.player.active,
                value: s.player.value || 0,
                // skip library generated id as it's not used
                matches: s.player.matches.map((m) => {
                    // eslint-disable-next-line
                    const { id, ...rest } = m;
                    return rest;
                }),
                meta: s.player.meta,
            },
            wins: s.matchPoints,
            tiebreaker: s.tiebreaks.medianBuchholz * 100000000 +
                s.tiebreaks.solkoff * 10000 +
                s.tiebreaks.cumulative,
        };
    })
        .sort((a, b) => b.matchPoints - a.matchPoints ||
        b.tiebreaker - a.tiebreaker ||
        b.player.value - a.player.value);
};
